import script from "./MyTransitions.vue?vue&type=script&setup=true&lang=js"
export * from "./MyTransitions.vue?vue&type=script&setup=true&lang=js"

import "./MyTransitions.vue?vue&type=style&index=0&id=5cf2b159&lang=scss"

const __exports__ = script;

export default __exports__